import PaymentLogos from "@/components/PaymentLogos";

export default function TrustBar() {
  return (
    <div data-testid="trust-bar" className="bg-[#0A0A0A] border-y border-[#C5B382]/20">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
        <span className="text-white/70 text-[11px] tracking-[0.22em] uppercase whitespace-nowrap">
          Secure checkout · Powered by
        </span>
        <PaymentLogos />
        <span className="hidden md:inline text-white/45 text-[11px] tracking-[0.18em] uppercase whitespace-nowrap">
          50% deposit to reserve
        </span>
      </div>
    </div>
  );
}
